<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="4" class="padding-r-0">
        <admin-shop @shop-change="handleShopSelected"></admin-shop>
      </el-col>
      <el-col :span="20">
        <el-card class="">
          <div slot="header" class="clearfix flex justify-between">
            <span>查询条件</span>
          </div>
          <el-form :inline="true" :model="adminShopVipInfo.conditions" class="flex justify-start">
            <el-form-item>
              <el-input v-model="adminShopVipInfo.conditions.vipName" placeholder="请输入会员名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="adminShopVipInfo.conditions.vipTel" placeholder="请输入电话" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="_queryShopVipUserMethod">查询</el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card class="margin-top-sm">
          <div slot="header" class="clearfix flex justify-between">
            <span>店铺会员</span>
          </div>
          <el-table :data="adminShopVipInfo.vips" border style="width: 100%">
            <el-table-column prop="vipId" label="会员编号" align="center"></el-table-column>
            <el-table-column prop="vipName" label="会员名称" align="center"></el-table-column>
            <el-table-column prop="vipTel" label="会员电话" align="center"></el-table-column>
            <el-table-column prop="sex" label="性别" align="center">
              <template slot-scope="scope">
                {{ scope.row.sex === '0' ? '女' : '男' }}
              </template>
            </el-table-column>
            <el-table-column prop="levelName" label="会员等级" align="center"></el-table-column>
            <el-table-column prop="birthday" label="会员生日" align="center"></el-table-column>
            <el-table-column prop="startTime" label="开始时间" align="center"></el-table-column>
            <el-table-column prop="endTime" label="结束时间" align="center"></el-table-column>
          </el-table>

          <el-pagination @current-change="handleCurrentChange" :current-page="adminShopVipInfo.conditions.page"
            :page-size="adminShopVipInfo.conditions.row" layout="total, prev, pager, next"
            :total="adminShopVipInfo.total"></el-pagination>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryAdminVipUser } from '@/api/shopVipUser/shopVipUserApi'
import AdminShop from '@/components/shop/adminShop'

export default {
  name: 'AdminShopVip',
  components: {
    AdminShop
  },
  data() {
    return {
      adminShopVipInfo: {
        vips: [],
        total: 0,
        records: 1,
        conditions: {
          vipName: '',
          vipTel: '',
          vipLevel: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listShopVipUsers(this.adminShopVipInfo.conditions.page, this.adminShopVipInfo.conditions.row)
  },
  methods: {
    handleShopSelected(shop) {
      this.adminShopVipInfo.conditions.shopId = shop.shopId
      this._listShopVipUsers(this.adminShopVipInfo.conditions.page, this.adminShopVipInfo.conditions.row)
    },
    async _listShopVipUsers(page, rows) {
      this.adminShopVipInfo.conditions.page = page
      this.adminShopVipInfo.conditions.row = rows

      try {
        const res = await queryAdminVipUser(this.adminShopVipInfo.conditions)
        this.adminShopVipInfo.total = res.total
        this.adminShopVipInfo.records = res.records
        this.adminShopVipInfo.vips = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _queryShopVipUserMethod() {
      this._listShopVipUsers(1, this.adminShopVipInfo.conditions.row)
    },
    handleCurrentChange(currentPage) {
      this._listShopVipUsers(currentPage, this.adminShopVipInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.padding-r-0 {
  padding-right: 0;
}

.ibox {
  margin-bottom: 20px;
}
</style>